import { render, staticRenderFns } from "./AccountStatementMail.vue?vue&type=template&id=8e71f98c&scoped=true"
import script from "./AccountStatementMail.vue?vue&type=script&lang=js"
export * from "./AccountStatementMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e71f98c",
  null
  
)

export default component.exports